import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    code: "BBA",
    major_name: "Bachelor of Business Administration"
  },
  {
    id: uuid(),
    code: "BAIS",
    major_name: "Bachelor of Arts in International Studies"
  },
  {
    id: uuid(),
    code: "BSCSC",
    major_name: "Bachelor of Science in Computer Science"
  },
  {
    id: uuid(),
    code: "BACS",
    major_name: "Bachelor of Arts in Communication Studies"
  },
  {
    id: uuid(),
    code: "BSEMS",
    major_name: "Bachelor of Science in Engineering and Management Sciences"
  },
  {
    id: uuid(),
    code: "BSGE",
    major_name: "Bachelor of Science in General Engineering"
  },
  {
    id: uuid(),
    code: "BSHRD",
    major_name: "Bachelor of Science in Human Resources Development"
  },
  {
    id: uuid(),
    code: "MBA",
    major_name: "Master of Business Administration"
  },
  {
    id: uuid(),
    code: "MAISD",
    major_name: "Master of Arts in International Studies and Diplomacy"
  },
  {
    id: uuid(),
    code: "NAMES",
    major_name: "Master of Arts in North African and Middle Eastern Studies"
  },
  {
    id: uuid(),
    code: "MAIRS",
    major_name: "Master of Arts in Islamic Religious Studies"
  },
  {
    id: uuid(),
    code: "MSSE",
    major_name: "Master of Science in Software Engineering"
  },
  {
    id: uuid(),
    code: "MSSEM",
    major_name: "Master of Science in Sustainable Energy Management "
  },
];
